module.exports = __webpack_public_path__ + "static/media/1.938d11d7.jpg";